export enum LeaderBoundary {
    savePct = 0.85,
    faceoffPct = 0.9,
    shotPct = 0.7,
    shotsOnGoalPct = 0.7,
    twoPointShotPct = 0.7,
    twoPointShotsOnGoalPct = 0.7
}